// URL guards for SSO browser navigation. Pure functions so they can be unit
// tested with `node --test` without a DOM (origin is injectable).

export function isSameOriginRedirect(value, origin = window.location.origin) {
  if (typeof value !== "string" || value.length === 0) return false
  // Must be a path on this origin: a single leading slash, never "//" (protocol
  // relative) or "/\" (which some browsers treat as "//").
  if (!value.startsWith("/")) return false
  if (value.startsWith("//") || value.startsWith("/\\")) return false

  try {
    return new URL(value, origin).origin === origin
  } catch {
    return false
  }
}

export function isAllowedProviderUrl(value) {
  if (typeof value !== "string" || value.length === 0) return false

  try {
    const url = new URL(value)
    if (url.username.length > 0 || url.password.length > 0) return false

    return url.protocol === "https:"
  } catch {
    return false
  }
}
